export default {"src":"/_next/static/media/logo-color.7fa62906.svg","height":1080,"width":1920};